
import { AuthModule } from './auth'
import { getStoreModule } from './appRuntime/store.js'
import { RouterModule } from './router'
import { NotificationsModule } from './notifications'
import { LifeCycleModule } from './lifeCycle'
import { PersonalizationModule } from './personalization'
import { OverrideWidgetsProperties } from './widgetsProperties'
import PageComponent from './PageComponent'
import { DataSourceModule } from './dataSources'
let gqTools = null

export default {
  async install(Vue, options) {
    let { store, model, graphQlTools, wsUrl } = options
    gqTools = graphQlTools

    Vue.component('PageComponent', PageComponent)
    let storeModel = await getStoreModule(Vue, model, gqTools)

    store.registerModule('appRunner', storeModel)
    
    options.dataSources = options.InitDataSources(storeModel.state.model.Modules.DefaultModuleImpl.DataSources)
    AuthModule.config(Vue, options)
    LifeCycleModule.config(Vue, store)
    PersonalizationModule.config(Vue, store, wsUrl)
    OverrideWidgetsProperties(store.getters.appModel, store.getters.appModel.UserModel)
    NotificationsModule.config(Vue, options)
    DataSourceModule.config(Vue, options)
    options.installCallback()
    await RouterModule.config(Vue, options)
  }
}

export { gqTools }